

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { PrintersContext } from '../../context/printers/PrinterContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';




export const PrinterPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { addPrinter, updatePrinter } = useContext(PrintersContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');

    var printer;

    if (state) {
        printer = state.printer;
    } else {
        printer = {
            id: -1,
            name: '',
            ip: '',
            typeId: -1
        }
    }


    const { formState, onInputChange } = useForm(printer);

    const { id, name, ip, typeId } = formState

    /* useEffect(() =>{
       const formValid =  name.length > 0 && ip.length > 0 && typeId > 0
       setIsFormValid(formValid);
     }, [name, ip, typeId])*/



    const handleSave = async () => {

        const formValid = name.length > 0 && ip.length > 0 && typeId > 0;

        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos");
            return;
        }


        var resp = "";
        if (id > 0) {
            resp = await updatePrinter(formState);
        } else {
            resp = await addPrinter(formState);
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Impresora actualizada correctamente" : "Impresora creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{id > 0 ? 'Actualizar impresora' : 'Crear impresora'}</h3>
                <hr />

                <form className="row g-3 " >



                    <div className="mb-3">
                        <label htmlFor="printerNameInput" className="form-label">Nombre *</label>
                        <input
                            id='printerNameInput'
                            type="text"
                            className={`form-control${required.mark(!name)}`}
                            placeholder="Nombre impresora"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="ipInput" className="form-label">IP *</label>
                        <input
                            id='ipInput'
                            type="text"
                            className={`form-control${required.mark(!ip)}`}
                            placeholder="192.168.0.131"
                            name="ip"
                            value={ip}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3 ">
                        <label htmlFor="typeIdSelect" className="form-label">Ubicacion *</label>
                        <select id='typeIdSelect' className={`form-select${required.mark(!(typeId > 0))}`} name='typeId' value={typeId} onChange={onInputChange} >
                            <option key={-1} value={-1} >Seleccione una opción</option>
                            <option key={0} value={1} >Cocina</option>
                            <option key={0} value={2} >Cajas</option>

                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>



                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
